module.exports = __webpack_public_path__ + "static/media/hub_image.bc380f4d.png";